import React, { Component } from 'react';
import { FormGroup, ControlLabel, Col, FormControl, HelpBlock } from 'react-bootstrap';
import ReactSelect from 'react-select';
import isString from 'lodash/isString';

export default class SelectField extends Component {

	denormalize(value, options, multiple) {
		if (value.length > 0 && multiple && isString(value[0])) {
			return value.map(v => ({ label: options.find((l) => l.value === v).label, value: v }));
		}
		return value;
	}

	render() {
		const {
			placeholder,
			instanceId,
			options,
			input,
			valueKey,
			labelKey,
			meta: { error, touched },
			label,
			id,
			layout,
			async,
			multiple,
			loadOptions,
			creatable,
			disabled,
			unclearable = false,
		} = this.props;

		const showError = error && touched;

		const selectBlock = () => {
			if (async) {
				return (
					<ReactSelect.Async
						instanceId={instanceId || `instanceId-${id || input.name}`}
						name={input.name}
						placeholder={placeholder}
						multi={multiple}
						value={this.denormalize(input.value, multiple)}
						onChange={input.onChange}
						valueKey={valueKey || 'value'}
						labelKey={labelKey || 'label'}
						loadOptions={loadOptions}
						disabled={disabled}
						clearable={!unclearable}
					/>
				);
			} else if (creatable) {
			return (
				<ReactSelect.Creatable
					instanceId={instanceId || `instanceId-${id || input.name}`}
					name={input.name}
					options={options || []}
					placeholder={placeholder}
					onChange={input.onChange}
					multi={multiple}
					value={input.value ? input.value : null}
					valueKey={valueKey || 'value'}
					labelKey={labelKey || 'label'}
					menuContainerStyle={{ zIndex: 5 }}
					disabled={disabled}
					clearable={!unclearable}
				/>
			);
		}
			return (
				<ReactSelect
					instanceId={instanceId || `instanceId-${id || input.name}`}
					name={input.name}
					options={options || []}
					placeholder={placeholder}
					onChange={input.onChange}
					multi={multiple}
					value={this.denormalize(input.value, options, multiple)}
					valueKey={valueKey || 'value'}
					labelKey={labelKey || 'label'}
					menuContainerStyle={{ zIndex: 5 }}
					disabled={disabled}
					clearable={!unclearable}
				/>

			);
		};

		const inputBlock = () => {
			return (
				<div>
					{selectBlock()}
					<FormControl.Feedback />
					<HelpBlock>{showError ? error : ''}</HelpBlock>
				</div>
			);
		};

		if (layout === 'horizontal') {
			return (
				<FormGroup controlId={id || input.name} validationState={showError ? 'error' : null}>
					<Col componentClass={ControlLabel} xs={3} className="control-label-horizontal">
						{label}
					</Col>
					<Col xs={9}>
						{inputBlock()}
					</Col>
				</FormGroup>
			);
		}

		return (
			<FormGroup
				controlId={id || input.name}
				className={label ? 'label-present' : 'label-blank'}
				validationState={showError ? 'error' : null}
			>
				{label ? <ControlLabel>{label}</ControlLabel> : ''}
				{inputBlock()}
			</FormGroup>
		);
	}
}
